import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import AppInterface from '../../api/AppInterface';
import { LTOPackageItemKeys } from '../../api/Constants';
import LevelUpInterface from '../../api/LevelUpInterface';
import PlayerInterface from '../../api/PlayerInterface';
import ShopInterface from '../../api/ShopInterface';
import { setPlayerId } from '../../state/actions/playerInfo';
import useFeatureFlags from '../../hooks/useFeatureFlags';
import { getMissions } from '../../state/query/missions';
import { setLTOOffer } from '../../state/slices/consumables/consumables';
import { store } from '../../state/store';
import Utils from '../../utils';
import TimeStampManager from '../../utils/TimestampManager';
import audio from '../../utils/audio';
import { FE_MISSIONS, FE_EVENTS } from '../../utils/featureFlags/constants';
import { ONBOARDING_FLOWS } from '../../utils/onboarding';
import { ltoCallBackHandler } from '../../utils/function';
import transformObjectArrayResponse from '../../utils/transformObjectArrayResponse';
import transformObjectResponseKeys from '../../utils/transformObjectResponseKeys';
import PushNotification from '../notifications/PushNotification';
import { fetchGameRooms } from '../../state/query/games/utils';
import { getEvents } from '../../state/query/events';
import { promoListHandler } from '../../utils/PromotionAction';

function fetchPlayerProfile() {
  return _fetchPlayerProfile.apply(this, arguments);
}

function _fetchPlayerProfile() {
  _fetchPlayerProfile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var profileRes;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return PlayerInterface.getPlayerProfile();

          case 2:
            profileRes = _context.sent;
            profileRes.playerId && store.dispatch(setPlayerId(profileRes.playerId));

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _fetchPlayerProfile.apply(this, arguments);
}

function fetchLevelUp() {
  return _fetchLevelUp.apply(this, arguments);
}

function _fetchLevelUp() {
  _fetchLevelUp = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return LevelUpInterface.tryLevelUp();

          case 2:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _fetchLevelUp.apply(this, arguments);
}

function prepareRender(_x, _x2) {
  return _prepareRender.apply(this, arguments);
}

function _prepareRender() {
  _prepareRender = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(data, assetsUrls) {
    var lobbyBackground, _iterator, _step, promotion, _iterator2, _step2, welcomeItem;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            lobbyBackground = data.LOBBY.lobby_background;
            _context3.next = 3;
            return this.props.preload("".concat(assetsUrls.promotionImagesUrl, "/").concat(lobbyBackground));

          case 3:
            _iterator = _createForOfIteratorHelper(data.PROMOTIONS);
            _context3.prev = 4;

            _iterator.s();

          case 6:
            if ((_step = _iterator.n()).done) {
              _context3.next = 12;
              break;
            }

            promotion = _step.value;
            _context3.next = 10;
            return this.props.preload("".concat(assetsUrls.promotionImagesUrl, "/").concat(promotion.image));

          case 10:
            _context3.next = 6;
            break;

          case 12:
            _context3.next = 17;
            break;

          case 14:
            _context3.prev = 14;
            _context3.t0 = _context3["catch"](4);

            _iterator.e(_context3.t0);

          case 17:
            _context3.prev = 17;

            _iterator.f();

            return _context3.finish(17);

          case 20:
            _iterator2 = _createForOfIteratorHelper(data.WELCOME);
            _context3.prev = 21;

            _iterator2.s();

          case 23:
            if ((_step2 = _iterator2.n()).done) {
              _context3.next = 29;
              break;
            }

            welcomeItem = _step2.value;
            _context3.next = 27;
            return this.props.preload("".concat(assetsUrls.ImagesCdnBaseUrl, "/").concat(welcomeItem.image));

          case 27:
            _context3.next = 23;
            break;

          case 29:
            _context3.next = 34;
            break;

          case 31:
            _context3.prev = 31;
            _context3.t1 = _context3["catch"](21);

            _iterator2.e(_context3.t1);

          case 34:
            _context3.prev = 34;

            _iterator2.f();

            return _context3.finish(34);

          case 37:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, this, [[4, 14, 17, 20], [21, 31, 34, 37]]);
  }));
  return _prepareRender.apply(this, arguments);
}

function fetchInitApp() {
  return _fetchInitApp.apply(this, arguments);
}

function _fetchInitApp() {
  _fetchInitApp = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
    var initAppRes, requiredXp, ltoResponse;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return AppInterface.initApp();

          case 2:
            initAppRes = _context4.sent;

            if (initAppRes.XP) {
              requiredXp = initAppRes.XP.XP_TO_NEXT + initAppRes.XP.CURRENT_XP;
              this.props.setXp(initAppRes.XP.CURRENT_XP);
              this.props.setXpBetMultiplier(initAppRes.XP.XP_BET_MULTIPLIER);
              this.props.setXpPerSpin(initAppRes.XP.XP_PER_SPIN);
              this.props.setNextBoostLevel(initAppRes.XP.LEVEL_META.nextBoostLevel);
              this.props.setNextBoostPercent(initAppRes.XP.LEVEL_META.nextBoostPercentage);
              this.props.setNextLevelBonusCoins(initAppRes.XP.LEVEL_META.nextLevelCoins);
              this.props.setCurrentLevelBonusCoins(initAppRes.XP.LEVEL_META.nextLevelCoins);
              this.props.setXpRequired(requiredXp);
              this.props.setMaxLevel(initAppRes.XP.MAX_LEVEL - 1); // NOTE: Bruno said to minus one from the number here
            }

            this.props.setDefaultPanels(initAppRes.DEFAULT_PANELS);
            this.props.setRegularPanels(initAppRes.REGULAR_PANELS);
            this.props.setStickyPanels(initAppRes.STICKY_PANELS);
            this.props.setCasinoIdStatus(initAppRes.CASINO_ID_STATUS);
            this.props.setCasinoId(initAppRes.CASINO_ID);

            if (initAppRes.SETTINGS) {
              this.props.setKYCStatus({
                isKYCDone: initAppRes.SETTINGS.kyocInfo.iskyocdone,
                KYCResult: initAppRes.SETTINGS.kyocInfo.kyocresult,
                KYCInfo: initAppRes.SETTINGS.kyocInfo.info
              });
              this.props.setSoundSettings({
                soundEffects: initAppRes.SETTINGS.soundEffects,
                music: initAppRes.SETTINGS.music
              });
            }

            if (initAppRes.PROPERTY_INFO) {
              this.props.setPropertyName(initAppRes.PROPERTY_INFO.propertyName);
            }

            this.props.setSaleAvailable(initAppRes.SALE); // Getting the array of favourite games from init app

            if (initAppRes.FAVOURITE) {
              this.props.setFavouriteGames(transformObjectArrayResponse(initAppRes.FAVOURITE.FAVOURITE_GAMES));
              this.props.setOnboardingUnlockLevel(ONBOARDING_FLOWS.FAVOURITES, initAppRes.FAVOURITE.UNLOCK_LEVEL);
            } // Set Video Ads Info: remaining videos and time remaining until videos refresh


            if (initAppRes.INVENTORY) {
              this.props.setVideosAdsInfo({
                remaining: initAppRes.INVENTORY.video,
                secondsUntilReset: initAppRes.WATCH_AND_EARN.seconds_until_reset
              });
            }

            if (initAppRes.LOBBY) {
              this.props.setLobbyBackgroundPromo(initAppRes.LOBBY.background);
            }

            promoListHandler({
              first_slide: initAppRes.PROMOTIONS,
              second_slide: initAppRes.PROMOTIONS_SECOND,
              third_slide: initAppRes.PROMOTIONS_THIRD
            }); // Will set the LTO in the store, and refresh as necessary.

            if (initAppRes.LIMITED_TIME_OFFER) {
              ltoResponse = transformObjectResponseKeys(initAppRes.LIMITED_TIME_OFFER, LTOPackageItemKeys);
              ltoResponse.OFFER_END_TIME = ltoResponse.TIME_LEFT_IN_SEC * 1000 + Date.now();
              this.props.setLTOOffer(ltoResponse);
              TimeStampManager.register(ltoResponse.TIME_LEFT_IN_SEC * 1000, ltoCallBackHandler(store, setLTOOffer));
            } // Will refresh active and free consumables


            ShopInterface.refreshActiveConsumables();
            /* #region Timed Bonus */

            if (initAppRes.TIMED_BONUS) {
              initAppRes.TIMED_BONUS.timeLeft = Date.now() + initAppRes.TIMED_BONUS.timeLeft * 1000;
              this.props.setTimedBonus(initAppRes.TIMED_BONUS);
            }

            return _context4.abrupt("return", initAppRes);

          case 20:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, this);
  }));
  return _fetchInitApp.apply(this, arguments);
}

function fetchFeatures() {
  return _fetchFeatures.apply(this, arguments);
}

function _fetchFeatures() {
  _fetchFeatures = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
    var _useFeatureFlags, hasFeature, playerId, dispatchInitiate;

    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _useFeatureFlags = useFeatureFlags(), hasFeature = _useFeatureFlags.hasFeature;
            playerId = store.getState().playerInfo.playerId;

            dispatchInitiate = function dispatchInitiate(feature, action) {
              if (hasFeature(feature)) {
                store.dispatch(action.initiate({
                  requestAssetsData: true,
                  playerId: playerId
                }, {
                  subscribe: false,
                  forceRefetch: true
                }));
              }
            };

            dispatchInitiate(FE_MISSIONS, getMissions);
            dispatchInitiate(FE_EVENTS, getEvents);

          case 5:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _fetchFeatures.apply(this, arguments);
}

export default function initApp() {
  return _initApp.apply(this, arguments);
}

function _initApp() {
  _initApp = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
    var initAppRes, loadingPromises, apiRequestsFailed;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            this.props.setIsInitAppExecuting(true);
            _context6.next = 3;
            return fetchInitApp.bind(this)();

          case 3:
            initAppRes = _context6.sent;
            loadingPromises = [fetchPlayerProfile(), fetchLevelUp(), fetchGameRooms(true, true), fetchFeatures()]; // Check if the app initialized from a notification
            // Not needed on android as it will run the onNotification handler

            Utils.getPlatform() === 'ios' && PushNotification.popInitialNotification();
            apiRequestsFailed = !this.props.assetsUrls || !initAppRes;
            _context6.t0 = !apiRequestsFailed;

            if (!_context6.t0) {
              _context6.next = 11;
              break;
            }

            _context6.next = 11;
            return prepareRender.bind(this)(initAppRes, this.props.assetsUrls);

          case 11:
            _context6.next = 13;
            return Promise.all(loadingPromises);

          case 13:
            // Schedule miss you push notification if enabled, clear if disabled
            Utils.getPlatform() !== 'web' && PushNotification.scheduleMissYouNotification();
            this.props.setIsInitAppExecuting(false);
            this.props.setLastInitApp(new Date().getTime());
            this.props.setInitAppResponse(initAppRes);
            audio.pauseSfx();
            audio.playMusic('backgroundMusic');
            /** Add whatever API data we need to fetch */

            return _context6.abrupt("return", {
              initAppRes: initAppRes
            });

          case 20:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, this);
  }));
  return _initApp.apply(this, arguments);
}